import React from "react";

export const CreateWorkspaceIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="none" viewBox="0 0 11 11">
      <path stroke="#7F869B" strokeLinecap="round" strokeWidth="1.094" d="M.547 5.563h9.906M5.437.547v9.906"></path>
    </svg>
  );
};
